<div
  #alertContainer
  class="alert alert-dismissible d-inline-flex"
  [ngClass]="{
    'w-100': fullWidth,
    'w-90 mx-4': isSmsUnpaidProcess,
    'alert-primary': alertStatus === 'primary',
    'alert-success': alertStatus === 'success',
    'alert-danger': alertStatus === 'danger',
    'alert-warning': alertStatus === 'warning',
    'alert-info': alertStatus === 'info'
  }"
  role="alert"
>
  <i class="alert-icon material-icons-round">{{ mainIcon }}</i>
  <ng-template #defaultTextTemplate>
    <div class="alert-content" [innerHTML]="alertText"></div>
  </ng-template>
  <ng-container *ngTemplateOutlet="alertTextTemplate ? alertTextTemplate : defaultTextTemplate"> </ng-container>

  <button *ngIf="sideIconIcon && sideIconText" (click)="onSideIconClick($event)" class="action alert-link btn btn-link">
    <i class="material-icons-round me-1">{{ sideIconIcon }}</i
    >{{ sideIconText }}
  </button>

  <button *ngIf="!sideIconIcon && sideIconText" (click)="onSideIconClick($event)" class="action alert-link btn btn-link">
    {{ sideIconText }}
  </button>

  <button *ngIf="showCloseBtn" type="button" class="btn-close" (click)="closeAlert()" aria-label="Close"></button>
</div>
